/* Oakridge PC — Bloom & Bond style landing: gallery, bundles, cart drawer, sticky bar, reviews. No apps required. */
(() => {
  // Sample (stand-in) review photos only show in the theme editor, when previewing an unpublished theme,
  // or on the live store for whoever opens the page with ?samples=1 (remembered for the tab; ?samples=0 turns it off).
  const role = window.Shopify && Shopify.theme && Shopify.theme.role;
  const sp = new URLSearchParams(location.search).get('samples');
  let samples = false;
  try {
    if (sp === '1') sessionStorage.setItem('bbSamples', '1');
    if (sp === '0') sessionStorage.removeItem('bbSamples');
    samples = sessionStorage.getItem('bbSamples') === '1';
  } catch (e) { samples = sp === '1'; }
  if ((window.Shopify && Shopify.designMode) || (role && role !== 'main') || samples) {
    document.documentElement.classList.add('bb-preview');
  }

  const money = (cents) => {
    const fmt = window.bbMoneyFormat || '${{amount}}';
    const n = (cents / 100);
    const v = fmt.includes('no_decimals') ? Math.round(n).toLocaleString('en-US')
      : n.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
    return fmt.replace(/\{\{\s*amount[a-z_]*\s*\}\}/, v);
  };
  const short = (cents) => money(cents).replace(/\.00(?!\d)/, '');

  /* ---------- gallery ---------- */
  document.querySelectorAll('[data-bb-gallery]').forEach((g) => {
    const track = g.querySelector('.bb-gal__track');
    const thumbs = [...g.querySelectorAll('.bb-gal__thumbs button')];
    const go = (i) => track.scrollTo({ left: track.clientWidth * i, behavior: 'smooth' });
    const cur = () => Math.round(track.scrollLeft / track.clientWidth);
    thumbs.forEach((b, i) => b.addEventListener('click', () => go(i)));
    g.querySelector('[data-prev]')?.addEventListener('click', () => go(Math.max(0, cur() - 1)));
    g.querySelector('[data-next]')?.addEventListener('click', () => go(Math.min(thumbs.length - 1, cur() + 1)));
    let t; track.addEventListener('scroll', () => {
      clearTimeout(t); t = setTimeout(() => {
        const i = cur(); thumbs.forEach((b, j) => b.classList.toggle('is-on', j === i));
        thumbs[i]?.scrollIntoView({ block: 'nearest', inline: 'nearest' });
      }, 60);
    }, { passive: true });
  });

  /* ---------- bundles (one source of truth shared by every picker on the page) ---------- */
  const state = { qty: null, label: '', sub: false };
  const pickers = [...document.querySelectorAll('bb-bundles')];

  function syncKaching(barId) {
    // While Kaching is installed its embed rewrites add-to-cart requests based on its own (hidden) selection.
    if (!barId) return;
    document.querySelectorAll(`kaching-bundle input[type=radio][value="${barId}"]`).forEach((r) => { if (!r.checked) r.click(); });
  }

  function render() {
    pickers.forEach((p) => {
      p.querySelectorAll('.bb-tier').forEach((t) => {
        const on = +t.dataset.qty === state.qty;
        t.classList.toggle('is-on', on);
        t.querySelector('input').checked = on;
      });
    });
    const tier = document.querySelector(`.bb-tier[data-qty="${state.qty}"]`);
    if (!tier) return;
    const total = +tier.dataset.total, compare = +tier.dataset.compare;
    document.querySelectorAll('[data-bb-price]').forEach((el) => (el.textContent = short(total)));
    document.querySelectorAll('[data-bb-qtytxt]').forEach((el) => (el.textContent = state.qty + (state.qty === 1 ? ' Bottle' : ' Bottles')));
    document.querySelectorAll('[data-bb-compare]').forEach((el) => {
      el.textContent = compare > total ? short(compare) : ''; el.hidden = !(compare > total);
    });
    document.querySelectorAll('[data-bb-saving]').forEach((el) => {
      el.hidden = !(compare > total);
      el.querySelector('.bb-save span').textContent = short(compare - total);
    });
    document.querySelectorAll('form[data-bb-form]').forEach((f) => {
      f.querySelector('[name=quantity]').value = state.qty;
      const prop = f.querySelector('[name="properties[_bundle]"]'); if (prop) prop.value = state.label;
      const sp = f.querySelector('[name=selling_plan]'); if (sp) sp.disabled = !state.sub;
    });
    syncKaching(tier.dataset.kaching);
  }

  pickers.forEach((p) => {
    p.addEventListener('change', (e) => {
      if (e.target.matches('.bb-tier input')) {
        const t = e.target.closest('.bb-tier');
        state.qty = +t.dataset.qty; state.label = t.dataset.label; render();
      }
      if (e.target.matches('[data-bb-sub]')) {
        state.sub = e.target.checked;
        document.querySelectorAll('[data-bb-sub]').forEach((c) => (c.checked = state.sub));
        render();
      }
    });
  });
  const want = new URLSearchParams(location.search).get('bundle');
  if (want) document.querySelectorAll(`.bb-tier[data-qty="${want}"] input`).forEach((i) => (i.checked = true));
  const first = document.querySelector('.bb-tier input:checked')?.closest('.bb-tier') || document.querySelector('.bb-tier');
  if (first) { state.qty = +first.dataset.qty; state.label = first.dataset.label; render(); }
  window.addEventListener('load', render);

  /* ---------- cart drawer ---------- */
  const drawer = document.querySelector('bb-cart');
  async function cartFetch(url, body) {
    const r = await fetch(url, {
      method: body ? 'POST' : 'GET',
      headers: body ? { 'Content-Type': 'application/json', Accept: 'application/json' } : { Accept: 'application/json' },
      body: body ? JSON.stringify(body) : undefined
    });
    const j = await r.json();
    if (!r.ok) throw new Error(j.description || j.message || 'Cart error');
    return j;
  }

  if (drawer) {
    const body = drawer.querySelector('.bb-cart__body');
    const foot = drawer.querySelector('.bb-cart__foot');
    const protId = +drawer.dataset.protection || 0;
    const open = () => { drawer.classList.add('is-open'); document.body.classList.add('bb-lock'); refresh(); };
    const close = () => { drawer.classList.remove('is-open'); document.body.classList.remove('bb-lock'); };
    window.bbOpenCart = open;
    drawer.querySelectorAll('[data-close]').forEach((b) => b.addEventListener('click', close));
    document.addEventListener('keydown', (e) => { if (e.key === 'Escape') close(); });
    document.querySelectorAll('[data-bb-open-cart]').forEach((a) => a.addEventListener('click', (e) => { e.preventDefault(); open(); }));

    const tplUp = drawer.querySelector('template[data-upsells]');

    function paint(cart) {
      document.querySelectorAll('[data-bb-count]').forEach((c) => { c.textContent = cart.item_count || ''; c.dataset.n = cart.item_count; });
      drawer.querySelector('[data-bb-items]').textContent = cart.item_count;
      const lines = cart.items.filter((i) => i.variant_id !== protId);
      if (!lines.length) {
        body.innerHTML = drawer.querySelector('template[data-empty]').innerHTML;
        foot.hidden = true; return;
      }
      foot.hidden = false;
      body.innerHTML = lines.map((i) => {
        const line = cart.items.indexOf(i) + 1;
        const disc = (i.line_level_discount_allocations || []).map((d) => d.discount_application.title).filter((t) => t && !t.startsWith('Subscribe Bundle')); // hide the subscription bundle discount name
        const img = i.image ? i.image.replace(/(\.[a-z]+)(\?|$)/i, '_160x160$1$2') : '';
        return `<div class="bb-line">
          <img src="${img}" alt="" loading="lazy" width="76" height="76">
          <div><div class="bb-line__t">${i.product_title}</div>
            ${i.variant_title && i.variant_title !== 'Default Title' ? `<div class="bb-line__v">${i.variant_title}</div>` : ''}
            ${i.selling_plan_allocation ? `<div class="bb-line__v">${i.selling_plan_allocation.selling_plan.name}</div>` : ''}
            ${disc.length ? `<div class="bb-line__disc">${disc.join(' · ')}</div>` : ''}
            <div class="bb-qty"><button type="button" data-line="${line}" data-q="${i.quantity - 1}" aria-label="Decrease">−</button><span>${i.quantity}</span><button type="button" data-line="${line}" data-q="${i.quantity + 1}" aria-label="Increase">+</button></div>
          </div>
          <div class="bb-line__p">${i.original_line_price > i.final_line_price ? `<s>${money(i.original_line_price)}</s>` : ''}${money(i.final_line_price)}
            <button type="button" class="bb-line__rm" data-line="${line}" data-q="0">Remove</button></div>
        </div>`;
      }).join('') + (tplUp ? tplUp.innerHTML : '');
      body.querySelectorAll('[data-add-variant]').forEach((b) => {
        if (cart.items.some((i) => i.variant_id === +b.dataset.addVariant)) b.closest('.bb-upsell').remove();
      });
      const prot = drawer.querySelector('[data-prot]');
      if (prot) prot.checked = cart.items.some((i) => i.variant_id === protId);
      const saved = cart.original_total_price - cart.total_price;
      drawer.querySelector('[data-bb-total]').innerHTML =
        (saved > 0 ? `<s>${money(cart.original_total_price)}</s>` : '') + money(cart.total_price);
      const sv = drawer.querySelector('[data-bb-saved]');
      sv.hidden = !(saved > 0); sv.querySelector('span').textContent = money(saved);
    }

    async function refresh() { paint(await cartFetch(`${bbRoutes.cart_url}.js`)); }
    async function busy(fn) {
      drawer.classList.add('is-busy');
      try { paint(await fn()); } catch (e) { console.warn('[bb-cart]', e); refresh(); }
      finally { drawer.classList.remove('is-busy'); }
    }

    drawer.addEventListener('click', (e) => {
      const q = e.target.closest('[data-line]');
      if (q) busy(() => cartFetch(`${bbRoutes.cart_change_url}.js`, { line: +q.dataset.line, quantity: +q.dataset.q }));
      const up = e.target.closest('[data-add-variant]');
      if (up) busy(async () => { await cartFetch(`${bbRoutes.cart_add_url}.js`, { items: [{ id: +up.dataset.addVariant, quantity: 1 }] }); return cartFetch(`${bbRoutes.cart_url}.js`); });
    });
    drawer.addEventListener('change', (e) => {
      if (!e.target.matches('[data-prot]')) return;
      busy(async () => {
        if (e.target.checked) await cartFetch(`${bbRoutes.cart_add_url}.js`, { items: [{ id: protId, quantity: 1 }] });
        else await cartFetch(`${bbRoutes.cart_change_url}.js`, { id: String(protId), quantity: 0 });
        return cartFetch(`${bbRoutes.cart_url}.js`);
      });
    });
    refresh();
  }

  /* ---------- add to cart (product forms on this page) ---------- */
  document.querySelectorAll('form[data-bb-form]').forEach((form) => {
    form.addEventListener('submit', async (e) => {
      e.preventDefault();
      if (form.dataset.busy) return; // ignore double taps while an add is in flight
      form.dataset.busy = '1';
      render(); // re-assert quantity in case another script touched the form
      const btns = document.querySelectorAll('[data-bb-atc]');
      btns.forEach((b) => b.setAttribute('disabled', ''));
      try {
        const r = await fetch(`${bbRoutes.cart_add_url}.js`, { method: 'POST', headers: { Accept: 'application/json' }, body: new FormData(form) });
        if (!r.ok) throw new Error((await r.json()).description || 'Could not add to cart');
        if (window.bbOpenCart) window.bbOpenCart(); else location.href = bbRoutes.cart_url;
      } catch (err) {
        console.warn('[bb-atc]', err);
        form.submit(); // fall back to the normal cart page
      } finally { delete form.dataset.busy; btns.forEach((b) => b.removeAttribute('disabled')); }
    });
  });
  // Buttons outside the main form (offer section, guarantee banner, sticky bar) submit the main form.
  document.querySelectorAll('[data-bb-submit]').forEach((b) => b.addEventListener('click', (e) => {
    e.preventDefault();
    const f = document.querySelector('form[data-bb-form]');
    if (f) f.requestSubmit ? f.requestSubmit() : f.dispatchEvent(new Event('submit', { cancelable: true }));
    else location.href = b.dataset.href || (window.bbRoutes ? bbRoutes.root + 'products/pc?bundle=5' : '/products/pc?bundle=5');
  }));
  document.querySelectorAll('[data-bb-scroll-buy]').forEach((b) => b.addEventListener('click', (e) => {
    e.preventDefault();
    const buy = document.getElementById('bb-buy'); if (!buy) { location.href = '/products/pc?bundle=5'; return; }
    buy.scrollIntoView({ behavior: 'smooth', block: 'start' });
  }));

  /* ---------- sticky bar ---------- */
  const sticky = document.querySelector('.bb-sticky');
  const anchor = document.querySelector('[data-bb-atc]');
  if (sticky && anchor && 'IntersectionObserver' in window) {
    new IntersectionObserver(([e]) => sticky.classList.toggle('is-on', !e.isIntersecting && e.boundingClientRect.top < 0)).observe(anchor);
  }

  /* ---------- reviews carousel ---------- */
  document.querySelectorAll('[data-bb-revs]').forEach((w) => {
    const track = w.querySelector('.bb-revs__track');
    const cards = [...track.children];
    const dots = w.querySelector('.bb-dots');
    const step = () => cards[0].getBoundingClientRect().width + 20;
    const max = () => track.scrollWidth - track.clientWidth;
    const stops = () => Math.round(max() / step()) + 1;
    const paintDots = () => { if (dots) dots.innerHTML = Array.from({ length: stops() }, () => '<i></i>').join(''); mark(); };
    // Arrows loop: past the last card goes back to the first, and the other way round.
    w.querySelector('[data-next]')?.addEventListener('click', () => {
      if (track.scrollLeft >= max() - 4) track.scrollTo({ left: 0, behavior: 'smooth' });
      else track.scrollBy({ left: step(), behavior: 'smooth' });
    });
    w.querySelector('[data-prev]')?.addEventListener('click', () => {
      if (track.scrollLeft <= 4) track.scrollTo({ left: max(), behavior: 'smooth' });
      else track.scrollBy({ left: -step(), behavior: 'smooth' });
    });
    const mark = () => {
      const i = track.scrollLeft >= max() - 4 ? stops() - 1 : Math.round(track.scrollLeft / step());
      dots?.querySelectorAll('i').forEach((d, k) => d.classList.toggle('is-on', k === i));
    };
    track.addEventListener('scroll', mark, { passive: true });
    window.addEventListener('resize', paintDots);
    w.querySelectorAll('.bb-rev').forEach((c) => {
      const more = c.querySelector('.bb-rev__more');
      if (more) more.addEventListener('click', () => { c.classList.toggle('is-open'); more.textContent = c.classList.contains('is-open') ? 'Read less' : 'Read more'; });
    });
    // Speed: measure (dots + which cards need "Read more") only once the carousel is on screen and laid out,
    // since sections below the first one skip layout until they're near the screen.
    const measure = () => {
      paintDots();
      w.querySelectorAll('.bb-rev').forEach((c) => {
        const txt = c.querySelector('.bb-rev__txt'), more = c.querySelector('.bb-rev__more');
        if (more && !c.classList.contains('is-open') && txt.scrollHeight <= txt.clientHeight + 2) more.remove();
      });
    };
    if ('IntersectionObserver' in window) {
      const io = new IntersectionObserver(([e]) => { if (e.isIntersecting) { io.disconnect(); requestAnimationFrame(measure); } });
      io.observe(w);
    } else requestAnimationFrame(measure);
  });
  /* ---------- light animations: stat count-up, timeline progress line, spinning border (only while on screen) ---------- */
  const calm = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  if ('IntersectionObserver' in window) {
    // Stats: count from 0 to the printed number once, when first seen.
    const statIO = new IntersectionObserver((ents) => ents.forEach((e) => {
      if (!e.isIntersecting) return; statIO.unobserve(e.target);
      const el = e.target, m = el.textContent.match(/^(\D*)([\d.,]+)(.*)$/); if (!m || calm) return;
      const end = parseFloat(m[2].replace(/,/g, '')), dur = 1300, t0 = performance.now();
      const tick = (t) => { const k = Math.min(1, (t - t0) / dur), v = Math.round(end * (1 - Math.pow(1 - k, 3)));
        el.textContent = m[1] + v.toLocaleString('en-US') + m[3]; if (k < 1) requestAnimationFrame(tick); };
      requestAnimationFrame(tick);
    }), { threshold: 0.6 });
    document.querySelectorAll('.bb-stat b').forEach((b) => statIO.observe(b));

    // Spinning border: runs only while the card is visible (no work off-screen).
    const spinIO = new IntersectionObserver((ents) => ents.forEach((e) => e.target.classList.toggle('is-in', e.isIntersecting)));
    document.querySelectorAll('.bb-cycle, .bb-chips, .bb-seal').forEach((c) => spinIO.observe(c));

    // Comparison table: rows rise in once when first seen.
    document.querySelectorAll('.bb-cmp').forEach((el) => {
      if (calm) return; el.classList.add('is-anim');
      const io = new IntersectionObserver(([e]) => { if (e.isIntersecting) { el.classList.add('is-in'); io.disconnect(); } }, { threshold: 0.2 });
      io.observe(el);
    });

    // "Real reason" steps: line fills down the numbered circles, each step lights up as the reading line passes it.
    document.querySelectorAll('.bb-steps').forEach((ol) => {
      const items = [...ol.querySelectorAll('li')]; if (!items.length) return;
      if (calm) { items.forEach((li) => li.classList.add('is-on')); ol.style.setProperty('--bb-sp', 1); return; }
      ol.classList.add('is-anim');
      let raf = 0;
      const update = () => { raf = 0; const line = innerHeight * 0.62, r = ol.getBoundingClientRect();
        const first = items[0].querySelector('i').getBoundingClientRect(), last = items[items.length - 1].querySelector('i').getBoundingClientRect();
        const a = first.top + first.height / 2, b = last.top + last.height / 2;
        const p = Math.max(0, Math.min(1, (line - a) / Math.max(1, b - a)));
        ol.style.setProperty('--bb-sp', (p > 0 ? Math.min(1, (a - r.top - 18 + p * (b - a)) / Math.max(1, r.height - 36)) : 0).toFixed(3));
        items.forEach((li) => { const c = li.querySelector('i').getBoundingClientRect(); li.classList.toggle('is-on', c.top + c.height / 2 <= line + 1); }); };
      const onScroll = () => { if (!raf) raf = requestAnimationFrame(update); };
      new IntersectionObserver(([e]) => {
        if (e.isIntersecting) { addEventListener('scroll', onScroll, { passive: true }); update(); }
        else { removeEventListener('scroll', onScroll); update(); }
      }, { rootMargin: '0px 0px -10% 0px' }).observe(ol);
    });

    // Timeline: desktop = horizontal line under the date pills; mobile = vertical rail beside the cards.
    // The scroll listener is attached only while the section is on screen.
    document.querySelectorAll('.bb-tl').forEach((sec) => {
      const bar = sec.querySelector('.bb-tl__bar'), wrap = sec.querySelector('.bb-tl__cards');
      const dots = bar ? [...bar.querySelectorAll('span')] : [], cards = wrap ? [...wrap.querySelectorAll('.bb-tlc')] : [];
      if (calm) { sec.style.setProperty('--bb-p', 1); sec.style.setProperty('--bb-pm', 1);
        dots.forEach((d) => d.classList.add('is-on')); cards.forEach((c) => c.classList.add('is-on')); return; }
      let raf = 0;
      const update = () => { raf = 0; const vh = innerHeight;
        if (bar && bar.offsetParent) {
          const r = sec.getBoundingClientRect();
          const p = Math.max(0, Math.min(1, (vh * 0.75 - r.top) / (r.height * 0.6)));
          sec.style.setProperty('--bb-p', p.toFixed(3));
          dots.forEach((d, i) => d.classList.toggle('is-on', i === 0 || p >= i / Math.max(1, dots.length - 1) - 0.001));
        } else if (wrap) {
          const line = vh * 0.62, r = wrap.getBoundingClientRect();
          sec.style.setProperty('--bb-pm', Math.max(0, Math.min(1, (line - r.top) / r.height)).toFixed(3));
          cards.forEach((c) => { const cr = c.getBoundingClientRect(); c.classList.toggle('is-on', cr.top + cr.height / 2 < line); });
        } };
      const onScroll = () => { if (!raf) raf = requestAnimationFrame(update); };
      new IntersectionObserver(([e]) => {
        if (e.isIntersecting) { addEventListener('scroll', onScroll, { passive: true }); update(); }
        else removeEventListener('scroll', onScroll);
      }).observe(sec);
    });
  }

  /* ---------- homepage cleanse quiz ---------- */
  document.querySelectorAll('bb-quiz').forEach((q) => {
    const steps = [...q.querySelectorAll('.bb-quiz__step')], back = q.querySelector('.bb-quiz__back'), bar = q.querySelector('.bb-quiz__bar');
    const imgs = q.querySelector('template[data-imgs]').content.firstElementChild.dataset, ans = {}; let cur = 1;
    const show = (n) => { cur = n; steps.forEach((s) => s.classList.toggle('is-on', +s.dataset.step === n));
      bar.style.setProperty('--q', Math.min(1, n / 3)); back.hidden = n === 1 || n === 4; };
    const why = { never: 'Two full 30-day rounds catch the eggs a short cleanse leaves behind.', returned: 'Symptoms coming back usually means round one never finished. Round two is what keeps it out.',
      quit: 'Berry flavor and the built-in pumpkin seed flush make this the cleanse you actually finish.' };
    const pain = { bloat: 'the bloating', crave: 'the sugar cravings', tired: 'the fatigue and fog', back: 'it coming back' };
    const result = () => { const n = ans[3] === 'me' ? 3 : 5, price = +q.dataset.price, paid = n === 3 ? 2 : 3;
      const fmt = (c) => '$' + (c / 100).toFixed(0);
      q.querySelector('[data-r-img]').src = n === 3 ? imgs.i3 : imgs.i5;
      q.querySelector('[data-r-title]').textContent = n === 3 ? '3 Bottles (Buy 2, Get 1 Free) — 90-Day Cleanse' : '5 Bottles (Buy 3, Get 2 Free) — Full Reset';
      q.querySelector('[data-r-why]').textContent = `For ${pain[ans[1]] || 'your symptoms'}: ${why[ans[2]] || ''}` + (n === 5 ? ' Five bottles covers two adults, or a full repeat cleanse.' : '');
      q.querySelector('[data-r-price]').textContent = `${fmt(price * paid)} total for ${n} bottles (${fmt(price * paid / n)} each)`; q.querySelector('[data-r-was]').textContent = fmt(price * n);
      q.querySelector('[data-r-cta]').href = q.dataset.url + '?bundle=' + n; show(4); };
    q.addEventListener('click', (e) => { const b = e.target.closest('.bb-quiz__step button'); if (!b) return;
      ans[cur] = b.dataset.v; cur < 3 ? show(cur + 1) : result(); });
    back.addEventListener('click', () => show(Math.max(1, cur - 1)));
    q.querySelector('.bb-quiz__redo').addEventListener('click', () => show(1));
  });
})();
